import React from "react";
import styles from "./index.module.scss";
import SkeletonC from "../../stories/common/skeleton";

export default function InvestorListingSkeleton() {
  return (
    <div className={styles.invListItemWrapper}>
          {Array.from({ length: 8 }).map((_, index) => (
        <div key={`skeleton-card-${index}`} className={styles.invCardWrapper}>
          <div className={styles.invCard}>
            <SkeletonC width="83px" height="24px" className={styles.TAG} />
          </div>
          <div className={styles.invCardDetails}>
            <SkeletonC width="100%" height="20px" className={styles.AccName} />
            <SkeletonC width="100%" height="20px" />
          </div>
        </div>
      ))}
    </div>
  );
}
